import {createAction} from '@reduxjs/toolkit';

import {ExpiringPoint} from 'types/campaign';

// HY TODO: move all other campaign related items here to reduce bloating the basket
export const fetchUserPointsAction = createAction<undefined>('FETCH_USER_POINTS');
export const setExpiringPointsAction = createAction<ExpiringPoint[] | undefined>('SET_EXPIRING_POINTS');
